import { Injectable } from '@angular/core';

export interface UserData {
  email: string;
  firstName: string;
  lastName: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserStorageService {
  private readonly emailKey = 'user_email';
  private readonly firstNameKey = 'user_firstName';
  private readonly lastNameKey = 'user_lastName';

  getUserData(): UserData | null {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }

    try {
      const email = localStorage.getItem(this.emailKey);
      const firstName = localStorage.getItem(this.firstNameKey);
      const lastName = localStorage.getItem(this.lastNameKey);

      if (email && firstName && lastName) {
        return {
          email,
          firstName,
          lastName
        };
      }

      return null;
    } catch (error) {
      console.warn('Erro ao ler dados do usuário do localStorage:', error);
      return null;
    }
  }

  saveUserData(email: string, firstName: string, lastName: string): void {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    try {
      localStorage.setItem(this.emailKey, email);
      localStorage.setItem(this.firstNameKey, firstName);
      localStorage.setItem(this.lastNameKey, lastName);
    } catch (error) {
      console.warn('Erro ao salvar dados do usuário no localStorage:', error);
    }
  }

  clearUserData(): void {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    try {
      localStorage.removeItem(this.emailKey);
      localStorage.removeItem(this.firstNameKey);
      localStorage.removeItem(this.lastNameKey);
    } catch (error) {
      console.warn('Erro ao limpar dados do usuário do localStorage:', error);
    }
  }
}

